import { randomNumber } from '../../utilities'
import NumberPadItemRow from './numberPadItemRow'

export default class NumberPadItemRows {
  key: string
  itemsPerRow: number
  items: NumberPadItemRow[]

  constructor(chars: string[] | undefined, itemsPerRow = 3) {
    this.key = randomNumber().toString()
    this.itemsPerRow = itemsPerRow

    this.items = []

    const size = this.itemsPerRow
    let idx = 0

    if (!chars) {
      return
    }

    let slicedArray = chars.slice(idx, idx + size)

    while (slicedArray.length) {
      if (chars.length > 12 && chars.length < 15 && slicedArray.length < 2) {
        this.items[this.items.length - 1].items = this.items[this.items.length - 1].items.concat(
          new NumberPadItemRow(slicedArray).items
        )
      } else {
        this.items.push(new NumberPadItemRow(slicedArray))
      }
      idx += size
      slicedArray = chars.slice(idx, idx + size)
    }
  }
}
